import { render, staticRenderFns } from "./ProfileAPIIndex.vue?vue&type=template&id=8fb031b8&scoped=true&"
import script from "./ProfileAPIIndex.vue?vue&type=script&lang=js&"
export * from "./ProfileAPIIndex.vue?vue&type=script&lang=js&"
import style0 from "./ProfileAPIIndex.vue?vue&type=style&index=0&id=8fb031b8&prod&scoped=true&lang=css&"
import style1 from "./ProfileAPIIndex.vue?vue&type=style&index=1&id=8fb031b8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fb031b8",
  null
  
)

export default component.exports